import type { ReactNode } from "react";

export default function PricePrefix({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  if (!children) {
    return null;
  }

  return <span className={className}>{children}</span>;
}

PricePrefix.displayName = "PricePrefix";
